<template>
    <div class="wrapper" ref="wrapper">
        <!-- LargeTooltip component -->
        <LargeTooltip
            ref="checklisttooltip"
            :class="[$store.state.checklist.activeInteraction, {'not-home' : !isHomePage, 'mirrored':mirrored}]"
            :title="tooltipText.title"
            :subtitle="tooltipText.subtitle"
            :video="tooltipText.video ? tooltipText.video : null"
            :arrow-pos="tooltipText.arrowpos"
        />
    </div>
</template>

<script>
import LargeTooltip from "../../../common/components/LargeTooltip.vue";
import {ChecklistInteractionEnum} from "../../../common/enums.js";

export default {
    name: "ChecklistTooltip",
    props:['mirrored'],
    components: {
        LargeTooltip
    },
    mounted() {
        if(this.isHomePage) {
            document.addEventListener("click", this.handleClickOutside);
        }
    },
    beforeUnmount() {
        if(!this.$store.state.checklist.subpage) {
            this.$store.state.checklist.activeInteraction = null;
        }
        document.removeEventListener("click", this.handleClickOutside);
    },
    methods: {
        handleClickOutside(event) {
            const wrapper = this.$refs.wrapper;
            const tooltip = this.$refs.checklisttooltip;

            if(wrapper && tooltip) {
                const tooltipEl = tooltip.$el

                // Get bounding rectangles of wrapper and tooltip
                const wrapperRect = wrapper.getBoundingClientRect();
                const tooltipRect = tooltipEl.getBoundingClientRect();

                // Check if the click event was inside either the wrapper or the tooltip
                const clickInsideWrapper = this.isInsideBoundingRect(wrapperRect, event);
                const clickInsideTooltip = this.isInsideBoundingRect(tooltipRect, event);

                // If click is outside both, handle it as an "outside click"
                if (!clickInsideWrapper && !clickInsideTooltip && this.isHomePage) {
                    if(this.$store.state.checklist.subpage && this.isHomePage) {
                        this.$store.state.checklist.subpage = false;
                    }else {
                        this.$store.state.checklist.activeInteraction = null;
                    }
                }
            }
        },
        isInsideBoundingRect(rect, event) {
            return (
                event.clientX >= rect.left &&
                event.clientX <= rect.right &&
                event.clientY >= rect.top &&
                event.clientY <= rect.bottom
            );
        }
    },
    computed: {
        tooltipText() {
            if(!this.isHomePage) {
                return {
                    title:'Go back to the home page',
                    subtitle: 'To complete this step, please go back to your home page.',
                    arrowpos:'top'
                }
            }

            switch (this.$store.state.checklist.activeInteraction) {
                case ChecklistInteractionEnum.HEADLINE:
                    return {
                        title: "Grab recruiters’ attention",
                        subtitle: "Turn a plain headline into one that’s clear and memorable.",
                        arrowpos: "left"
                    };
                case ChecklistInteractionEnum.THUMBNAIL:
                    return {
                        title: "Design a thumbnail",
                        subtitle: "Turn raw screenshots into visuals that make recruiters want to click.",
                        arrowpos: "left"
                    }
                case ChecklistInteractionEnum.LAYOUT:
                    return {
                        title: "Select a layout",
                        subtitle: "Make your portfolio unique by changing the case study grid layout.",
                        arrowpos: "right",
                    }
                case ChecklistInteractionEnum.RESUME:
                    return {
                        title: "Add a resume page",
                        subtitle: "Make it easier for recruiters to access your resume.",
                        arrowpos: "left"
                    }
                case ChecklistInteractionEnum.DOMAIN:
                    return {
                        title: "Customize your domain",
                        subtitle: "Make a professional first impression with a custom domain name.",
                        arrowpos: "left"
                    }
                case ChecklistInteractionEnum.CASE_STUDY:
                    return {
                        title: "Generate a case study",
                        subtitle: "Use AI to turn your project into a compelling case study.",
                        arrowpos: "left"
                    }
                case ChecklistInteractionEnum.CUSTOMIZE:
                    return {
                        title: "Add personality",
                        subtitle: "Update the colors to give your portfolio a personal touch.",
                        arrowpos: "left center"
                    }
                case ChecklistInteractionEnum.PUBLISH:
                    return {
                        title: "Go live! 🚀",
                        subtitle: "Hit Publish & share your portfolio with the world!",
                        arrowpos: "top top-right"
                    }
                default:
                    return {
                        title: "Title",
                        subtitle: "Subtitle",
                        arrowpos: "left"
                    }
            }
        },
        isHomePage() {
            return this.$store.getters.isHomePage;
        },
    }
};
</script>

<style scoped lang="scss">
.wrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    pointer-events: none; /* Allow pointer events */
}

.headline {
    left: 280px;
    top: 100px;
}

.layout {
    position: absolute;
    top: 6px;
    right: 355px;
}

.resume {
    left: 390px;
    position: fixed;
    top: 550px;
}

.customize {
    left: 370px;
    position: fixed;
    top: 477px;
}

.domain {
    position: fixed;
    top: 320px;
    left: 370px;
}

.publish {
    top: 70px;
    right: 53px;
}

.thumbnail {
    position: absolute;
    top: 128px;
    right: -310px;

    &.mirrored {
        @media (max-width: 1900px) {
            transform: scaleX(-1);
            right: 250px;
            z-index: 9;

            :deep(.text-wrapper) {
                transform: scaleX(-1);
            }
        }
    }
}

.caseStudy {
    right: -330px;
    top: -5px;
    position: absolute;
}

.not-home {
    left: 0;
    top: 80px;
    position: absolute;
}
</style>
